$(function(){
	var params = {
		'lazyLoad': 'ondemand',
		'slidesToShow': 4, 
		'slidesToScroll': 1,
		'respondTo': 'slider', 
		'responsive':[
			{
				'breakpoint': 1200,
				'settings': {
					'slidesToShow': 3
				}
			},
			{
				'breakpoint': 767,
				'settings': {
					'slidesToShow': 2
				}
			},
			{
				'breakpoint': 420,
				'settings': {
					'slidesToShow': 1
				}
			}
		]
	};

	$('.slider-block').slick(params);
});